import React from 'react';

/**
 * Pure presentational shell around the html5-qrcode mount point.
 * The actual camera lifecycle (start/stop/cleanup) lives in the BarcodeScanner
 * parent — DO NOT move it here, it relies on refs that must survive remounts.
 */
export default function CameraView({ isScanning, feedbackMessage }) {
  return (
    <div>
      <div className="relative bg-gray-900 rounded-lg overflow-hidden mb-4">
        {/* html5-qrcode mount target — DO NOT rename this id */}
        <div id="barcode-scanner-reader" className="w-full"></div>

        {!isScanning && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white p-4">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-3"></div>
              <p>Starting camera...</p>
            </div>
          </div>
        )}

        {feedbackMessage && (
          <div className="absolute inset-0 flex items-center justify-center bg-green-500 bg-opacity-30 pointer-events-none">
            <div className="bg-green-600 text-white px-6 py-3 rounded-lg text-xl font-bold shadow-lg" data-testid="scanner-feedback">
              {feedbackMessage}
            </div>
          </div>
        )}
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <h3 className="font-semibold text-blue-900 mb-2">How to scan:</h3>
        <ol className="text-sm text-blue-800 space-y-1 list-decimal list-inside">
          <li>Position the barcode inside the scanning area</li>
          <li>Hold steady until it scans automatically</li>
          <li>Make sure there's good lighting</li>
          <li>If scanning fails, switch to manual entry</li>
        </ol>
      </div>

      <div className="text-xs text-gray-500 text-center">
        Supports: EAN-13, ISBN-10, ISBN-13, UPC-A
      </div>
    </div>
  );
}
